// @flow
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import * as React from 'react';
import { withConfirmation } from 'speed-js-react';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { withLeaflet } from 'react-leaflet';
import { isEqual } from 'lodash';
import cableAndFiberMessages from 'esm-web-pro/messages/cableAndFiberMessages';
import FiberDamageAction from 'esm-web-pro/containers/pages/network/objects/fiber/FiberDamageAction';
import { numberPointsCallbacksFiber } from 'esm-web-pro/containers/pages/network/objects/fiber/MapFiber';
import { CableFiberColor, FiberTextContainer } from 'esm-web-pro/containers/pages/network/objects/cable/CableFiber';

type Props = {
    cable: Object,
    fiber: Object,
    onFix: Function,
    intl: IntlShape,
    map: Object,
    onView: Function,
    setClickedRowIdentity: Function,
    clickedRowIdentity: string,
    highlightFiber: Function,
    pointCoords: [number, number],
}

const DamagedFiberRow = (props: Props) => {
    const {
        cable, fiber, onFix, intl: { formatMessage }, map, onView, clickedRowIdentity,
        setClickedRowIdentity, highlightFiber, pointCoords,
    } = props;

    const visualise = (e) => {
        let path = cable.path.map((c) => [c[1], c[0]]);
        if (!isEqual(pointCoords, path[0])) {
            path = path.reverse();
        }
        const focusFiberCallback = highlightFiber(path, true);
        onView(e, [
            focusFiberCallback,
            ...numberPointsCallbacksFiber({ container: cable }),
        ], path);
    };
    const rowId = `${cable.id}-${fiber.sequence_number}`;

    return (
        <ContentRow
            hoverIndicator="none"
            onClick={(e) => {
                setClickedRowIdentity(rowId);
                visualise(e);
            }}
            padLevel={2}
            key={cable.uuid}
            object={cable}
            actions={(
                <FiberDamageAction
                    map={map}
                    fiber={fiber}
                    ActionComponent={RowActions}
                    damaged
                    actionProps={{
                        size: '20px',
                        width: '3px',
                        tooltip: true,
                    }}
                    pad={{ right: '15px' }}
                    updateObject={onFix}
                />
            )}
            rowId={rowId}
            clickedRowIdentity={clickedRowIdentity}
        >
            <FiberTextContainer>
                {(fiber.attributes?.color) && (
                    <CableFiberColor
                        color={fiber.attributes.color}
                        stripeCount={fiber.attributes.stripe_count}
                        tubeNumber={fiber.attributes.tube_number}
                    />
                )}
                {`${formatMessage(cableAndFiberMessages.fiberLong)} ${fiber.sequence_number}`}
            </FiberTextContainer>
        </ContentRow>
    );
};

export default withLeaflet(injectIntl(withConfirmation(DamagedFiberRow)));
